// /* eslint-disable import/no-anonymous-default-export */
// import {
//     FETCH_INIT,
//     FETCHED,
//     FETCHED_FAIL,
//     SET_FILTER,
//     SET_SORTING,
//     CHANGE_PAGE,
//     SET_SERVER_PAGE,
//     SET_ROW_SIZE,
//     CLEAN_UPCOMING_SESSIONS,
//     RESET_FILTER,
//     CHANGE_STATUS,
// } from "../actions/DietitianUpcomingSessions";

// /**
//  * Slices the flat `all` array to the rows visible on `pageId`.
//  * Matches the same helper used in AllDoctors.reducer.js.
//  */
// function mapPresetPRequest(all, pageId, rowsPerPage) {
//     return all.filter((_val, index) => {
//         const start = (pageId + 1) * rowsPerPage - rowsPerPage;
//         const end = (pageId + 1) * rowsPerPage;
//         return index >= start && index < end;
//     });
// }

// const INITIAL_STATE = {
//     all: [],
//     present: [],
//     query: null,
//     query_data: null,
//     sorting_data: { row: null, order: null },
//     is_fetching: false,
//     is_loading: false,
//     currentPage: 0,
//     serverPage: 0,
//     rowsPerPage: 10,
//     resetCounter: 0,
//     filter: {},
// };

// export default function (state = JSON.parse(JSON.stringify(INITIAL_STATE)), action) {
//     switch (action.type) {
//         case FETCH_INIT: {
//             return { ...state, is_fetching: true, is_loading: true };
//         }

//         case FETCHED: {
//             const newData = action.payload.data?.list || [];
//             const page = action.payload.page;
//             // Page 1 replaces; subsequent pages are appended
//             const newAll = page === 1 ? [...newData] : [...state.all, ...newData];
//             const tableData = mapPresetPRequest(newAll, state.currentPage, state.rowsPerPage);
//             return {
//                 ...state,
//                 all: newAll,
//                 present: tableData,
//                 is_fetching: false,
//                 is_loading: false,
//                 serverPage: page,
//                 allRowSelected: false,
//             };
//         }

//         case FETCHED_FAIL: {
//             return {
//                 ...state,
//                 all: [],
//                 present: [],
//                 is_fetching: false,
//                 is_loading: false,
//             };
//         }

//         case SET_FILTER: {
//             return {
//                 ...state,
//                 query: action.payload?.query,
//                 query_data: action.payload?.query_data,
//                 filter: action.payload,
//             };
//         }

//         case SET_SORTING: {
//             return {
//                 ...state,
//                 sorting_data: action.payload,
//             };
//         }

//         case CHANGE_PAGE: {
//             const tempPage = action.payload;
//             const tableData = mapPresetPRequest(state.all, tempPage, state.rowsPerPage);
//             return { ...state, present: tableData, currentPage: tempPage };
//         }

//         case SET_SERVER_PAGE: {
//             return { ...state, serverPage: action.payload };
//         }

//         case SET_ROW_SIZE: {
//             const tableData = mapPresetPRequest(state.all, 0, action.payload);
//             return { ...state, rowsPerPage: action.payload, present: tableData, currentPage: 0 };
//         }

//         case CLEAN_UPCOMING_SESSIONS: {
//             return JSON.parse(JSON.stringify(INITIAL_STATE));
//         }

//         case RESET_FILTER: {
//             return {
//                 ...JSON.parse(JSON.stringify(INITIAL_STATE)),
//                 resetCounter: state.resetCounter + 1,
//             };
//         }

//         case CHANGE_STATUS: {
//             const updatedAll = state.all.map((item) => {
//                 if (item.id === action.payload.id) {
//                     return { ...item, status: action.payload.status };
//                 }
//                 return item;
//             });
//             const tableData = mapPresetPRequest(updatedAll, state.currentPage, state.rowsPerPage);
//             return { ...state, all: updatedAll, present: tableData };
//         }

//         default: {
//             return state;
//         }
//     }
// }

import {
    FETCH_INIT,
    FETCHED,
    FETCHED_FAIL,
    SET_FILTER,
    SET_SORTING,
    CHANGE_PAGE,
    SET_SERVER_PAGE,
    SET_ROW_SIZE,
    CLEAN_UPCOMING_SESSIONS,
    RESET_FILTER,
    CHANGE_STATUS,
    RESET_TABLE_DATA
} from "../actions/DietitianUpcomingSessions";

/**
 * Slices the flat `all` array to the rows visible on `pageId`.
 * Matches the same helper used in AllDoctors.reducer.js.
 */
function mapPresetPRequest(all, pageId, rowsPerPage) {
    return all.filter((_val, index) => {
        const start = (pageId + 1) * rowsPerPage - rowsPerPage;
        const end = (pageId + 1) * rowsPerPage;
        return index >= start && index < end;
    });
}

const INITIAL_STATE = {
    all: [],
    present: [],
    query: null,
    query_data: null,
    sorting_data: { row: null, order: null },
    is_fetching: false,
    is_loading: false,
    currentPage: 0,
    serverPage: 0,
    rowsPerPage: 10,
    resetCounter: 0,
    filter: {},
};

export default function (state = JSON.parse(JSON.stringify(INITIAL_STATE)), action) {
    switch (action.type) {
        case FETCH_INIT: {
            return { ...state, is_fetching: true, is_loading: true };
        }

        case FETCHED: {
            const responseData = action.payload?.data || action.payload || {};
            const newData = responseData?.response_obj?.list || responseData?.list || [];
            const page = action.payload?.page || 0;
            // Page 0 replaces; subsequent pages are appended
            const newAll = page === 0 ? [...newData] : [...state.all, ...newData];
            const tableData = mapPresetPRequest(newAll, state.currentPage, state.rowsPerPage);
            return {
                ...state,
                all: newAll,
                present: tableData,
                is_fetching: false,
                is_loading: false,
                serverPage: page,
                allRowSelected: false,
            };
        }

        case FETCHED_FAIL: {
            return {
                ...state,
                all: [],
                present: [],
                is_fetching: false,
                is_loading: false,
            };
        }

        case SET_FILTER: {
            return {
                ...state,
                query: action.payload?.query,
                query_data: action.payload?.query_data,
                filter: action.payload,
            };
        }

        case SET_SORTING: {
            return {
                ...state,
                sorting_data: action.payload,
            };
        }

        case CHANGE_PAGE: {
            const tempPage = action.payload;
            const tableData = mapPresetPRequest(state.all, tempPage, state.rowsPerPage);
            return { ...state, present: tableData, currentPage: tempPage };
        }

        case SET_SERVER_PAGE: {
            return { ...state, serverPage: action.payload };
        }

        case SET_ROW_SIZE: {
            const tableData = mapPresetPRequest(state.all, 0, action.payload);
            return { ...state, rowsPerPage: action.payload, present: tableData, currentPage: 0 };
        }

        case CLEAN_UPCOMING_SESSIONS: {
            return JSON.parse(JSON.stringify(INITIAL_STATE));
        }

        case RESET_FILTER: {
            return {
                ...JSON.parse(JSON.stringify(INITIAL_STATE)),
                resetCounter: state.resetCounter + 1,
            };
        }

        case CHANGE_STATUS: {
            const updatedAll = state.all.map((item) => {
                if (item.id === action.payload.id) {
                    return { ...item, status: action.payload.status };
                }
                return item;
            });
            const tableData = mapPresetPRequest(updatedAll, state.currentPage, state.rowsPerPage);
            return { ...state, all: updatedAll, present: tableData };
        }

        case RESET_TABLE_DATA: {
            return {
                ...state,
                all: [],
                present: [],
                currentPage: 0,
                serverPage: 0
            };
        }

        default: {
            return state;
        }
    }
}